import {computed, ref} from 'vue'
import {defineStore} from 'pinia'

export type ToggleState = 'notAllowed' | 'off' | 'on'

// Same transitions as the former `app.recording` / `app.liveCaption` machine states:
// notAllowed -> off <-> on, off -> notAllowed
export const createToggleStore = (id: 'recording' | 'liveCaption') =>
  defineStore(id, () => {
    const state = ref<ToggleState>('notAllowed')

    const isNotAllowed = computed(() => state.value === 'notAllowed')
    const isOff = computed(() => state.value === 'off')
    const isOn = computed(() => state.value === 'on')

    function allow() {
      if (state.value === 'notAllowed') state.value = 'off'
    }

    function deny() {
      if (state.value === 'off') state.value = 'notAllowed'
    }

    function start() {
      if (state.value === 'off') state.value = 'on'
    }

    function stop() {
      if (state.value === 'on') state.value = 'off'
    }

    return {state, isNotAllowed, isOff, isOn, allow, deny, start, stop}
  })
